export const dataTestIds = {
  landing: {
    clearFilterButton: 'clear-filter-button',
    modularPill: 'modular-pill',
    removableCoverPill: 'removable-cover-pill',
    sofaBedPill: 'sofa-bed-pill',
    startPageGallery: 'startpage-gallery',
    startPageIntroTitle: 'startpage-intro-title',
    storagePill: 'storage-pill',
    widthPill: 'width-pill',
  },
  planner: {
    armrestChoicePicker: 'armrest-choice-picker',
    legsChoicePicker: 'legs-choice-picker',
    mattressChoicePicker: 'mattress-choice-picker',
    mirrorConfigurationButton: 'mirror-configuration-button',
    overflowLegsChoicePickerButton: 'overflow-legs-choice-picker-button',
    overflowMattressChoicePickerButton: 'overflow-mattress-choice-picker-button',
    productCovers: 'product-covers',
    productListShowLessButton: 'product-list-show-less-button',
    productListShowMoreButton: 'product-list-show-more-button',
    productVariations: 'product-variations',
    sofaBedButton: 'sofa-bed-button',
    storageButton: 'storage-button',
    youMayPrefer: 'you-may-prefer-product-list',
    sofaTitle: 'sofa-title',
    designYourOwnLink: 'design-your-own-link',
    closeSidebar: 'close-button',
    coverPicker: 'cover-picker',
    additionalInformationButton: 'additional-information-button',
  },
}
